import api from './client';
import type { Planning, ChargeArtisanResponse } from 'types/planning';

interface PlanningCreatePayload {
  project_id: string;
  org_id: string;
  model: string;
  start_date: string;
  sections: Planning['sections'];
}

interface PlanningUpdatePayload {
  model?: string;
  start_date?: string;
  sections?: Planning['sections'];
}

export const planningsApi = {
  list: async (params: { org_id: string; project_id?: string }): Promise<Planning[]> => {
    const { data } = await api.get('/plannings', { params });
    return data as Planning[];
  },

  get: async (planningId: string): Promise<Planning> => {
    const { data } = await api.get(`/plannings/${planningId}`);
    return data as Planning;
  },

  create: async (payload: PlanningCreatePayload): Promise<Planning> => {
    const { data } = await api.post('/plannings', payload);
    return data as Planning;
  },

  update: async (planningId: string, payload: PlanningUpdatePayload): Promise<Planning> => {
    const { data } = await api.patch(`/plannings/${planningId}`, payload);
    return data as Planning;
  },

  delete: async (planningId: string): Promise<void> => {
    await api.delete(`/plannings/${planningId}`);
  },

  getChargeArtisan: async (params: {
    org_id: string;
    section_key: string;
  }): Promise<ChargeArtisanResponse> => {
    const { data } = await api.get('/plannings/charge-artisan', { params });
    return data as ChargeArtisanResponse;
  },
};
